// Reports — tabbed shell that hosts the five report views.
// Date range lives at this level so switching tabs keeps the window.

import React, { useState } from "react";
import OverviewReport     from "./reports/OverviewReport";
import ReservationsReport from "./reports/ReservationsReport";
import RoomsReport        from "./reports/RoomsReport";
import GuestsReport       from "./reports/GuestsReport";
import BillingReport      from "./reports/BillingReport";

const TABS = [
  { id: "overview",     icon: "📊", label: "Overview",     desc: "System-wide health" },
  { id: "reservations", icon: "📋", label: "Reservations", desc: "Bookings + cancellations" },
  { id: "rooms",        icon: "🏨", label: "Rooms",        desc: "Inventory + utilisation" },
  { id: "guests",       icon: "👥", label: "Guests",       desc: "Guest book + repeats" },
  { id: "billing",      icon: "💰", label: "Billing",      desc: "Revenue + outstanding" },
];

// Default to last 30 days so the operator sees something meaningful even
// before they touch the date picker.
function defaultRange() {
  const to = new Date();
  const from = new Date(); from.setDate(from.getDate() - 30);
  return {
    from: from.toISOString().slice(0, 10),
    to:   to.toISOString().slice(0, 10),
  };
}

export default function Reports() {
  const [tab, setTab] = useState("overview");
  const [range, setRange] = useState(defaultRange);

  const renderTab = () => {
    const props = { range, onRangeChange: setRange };
    switch (tab) {
      case "overview":     return <OverviewReport     {...props}/>;
      case "reservations": return <ReservationsReport {...props}/>;
      case "rooms":        return <RoomsReport        {...props}/>;
      case "guests":       return <GuestsReport       {...props}/>;
      case "billing":      return <BillingReport      {...props}/>;
      default:             return <OverviewReport     {...props}/>;
    }
  };

  return (
    <div>
      {/* Tab pills — each one a card with the icon and a one-line hint */}
      <div style={{
        display: "grid", gap: 8, marginBottom: 20,
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      }}>
        {TABS.map(t => {
          const on = tab === t.id;
          return (
            <button key={t.id} type="button"
              onClick={() => setTab(t.id)}
              style={{
                textAlign: "left", padding: "12px 14px", borderRadius: 10,
                background: on ? "linear-gradient(135deg, #c8a05a, #a8814a)" : "#fff",
                border: `1.5px solid ${on ? "#a8814a" : "rgba(180,140,80,.22)"}`,
                color: on ? "#1a110a" : "#3a2a1a",
                cursor: "pointer",
                fontFamily: "'Jost', sans-serif",
                transition: "background .15s, border-color .15s, transform .1s",
              }}
              onMouseEnter={(e) => { if (!on) e.currentTarget.style.background = "#fdf8f2"; }}
              onMouseLeave={(e) => { if (!on) e.currentTarget.style.background = "#fff"; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 18 }}>{t.icon}</span>
                <span style={{ fontWeight: 600, fontSize: 13.5, letterSpacing: ".04em" }}>{t.label}</span>
              </div>
              <div style={{ fontSize: 11.5, color: on ? "rgba(26,17,10,.7)" : "#6b5142", marginTop: 4 }}>
                {t.desc}
              </div>
            </button>
          );
        })}
      </div>

      {renderTab()}
    </div>
  );
}
